import { COLORS } from '@btime/constants'
import { FilterHandler } from '@btime/react-contexts'
import React from 'react'

import { PermissionChecker } from '../../session'
import AbsoluteWithMenuSpacePageTemplate from '../../../components/templates/AbsoluteWithMenuSpacePageTemplate'
import AddNewButton from './AddNewButton'
import ChecklistsLoader from './_load/ChecklistsLoader'
import ChecklistsTable from './table/ChecklistsTable'
import Container from '../../../components/structure/Container'
import ControlBar from './ControlBar'
import MultiRowsActions from './table/MultiRowsActions'
import MultiSelectHandler from '../../../packages/kiti/components/multiSelect/MultiSelectHandler'
import PageHeader from './PageHeader'
import Separator from '../../../components/helpers/Separator'

const ChecklistsListPage = () => {
  return (
    <AbsoluteWithMenuSpacePageTemplate bgColor={COLORS.white}>
      <PermissionChecker permission="listChecklist">
        <Container>
          <PageHeader />
          <FilterHandler tempStorageNamespace="checklists" initialState={{ fixedFilterFields: ['usages'] }}>
            <ControlBar />
            <MultiSelectHandler>
              <ChecklistsLoader uncontrolledChildren={<MultiRowsActions />}>
                <ChecklistsTable />
              </ChecklistsLoader>
            </MultiSelectHandler>
          </FilterHandler>

          <AddNewButton />
          <Separator weight={90} />
        </Container>
      </PermissionChecker>
    </AbsoluteWithMenuSpacePageTemplate>
  )
}

export default ChecklistsListPage
